import React, { useEffect, useRef, useState } from 'react';
import { string } from 'prop-types';
import { revJetConfig } from './RevJetConfig';

export const RevJet = (props) => {

  const {
    itemId,
    envSpace,
    parentId,
  } = props;

  const [revJetLoaded, setRevJetLoaded] = useState(false);
  const revJetRef = useRef(null);

  const revJetOnload = () => {
    if (window && revJetRef.current) {
      window.revjet = window.revjet || {};
      window.revjet.tags = window.revjet.tags || [];
      window.revjet.tags.push({
        _tag: revJetConfig[envSpace].tag,
        _plc_id: revJetConfig[envSpace].plc_id,
        _key: revJetConfig[envSpace].key,
        _opts: {
          embd_tag_id: (function (doc) {
            const tag = doc.createElement('div');
            tag.id = 'revjet-tag-' + window.revjet.tags.length;
            const scriptRevJet = revJetRef.current;
            if (scriptRevJet) {
              scriptRevJet.prepend(tag);
            }
            return tag.id;

          }(document)),
          responsive: true,
          autoscale: false,
          autohide: true,
          responsive_height: 'dynamic',
          delivery_method: 'banner',
          _imp_banner_size: '1400x1400',
        },
        omsid: itemId
      });
    }
  };

  const resetRevJetChildren = () => {
    if (revJetRef?.current?.children?.length > 0) {
      Array.from(revJetRef.current.children).forEach((child) => {
        revJetRef.current.removeChild(child);
      });
    }
  };

  useEffect(() => {
    if (revJetRef.current && revJetLoaded) {
      revJetOnload();
    }
  }, [revJetRef.current, revJetLoaded]);

  useEffect(() => {
    const script = document.createElement('script');

    script.onload = () => {
      setRevJetLoaded(true);
    };
    script.src = revJetConfig[envSpace].path;
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
      resetRevJetChildren();
      setRevJetLoaded(false);
    };
  }, [itemId]);

  return (
    <div id={parentId} ref={revJetRef} />
  );
};

RevJet.displayName = 'RevJet';

RevJet.propTypes = {
  itemId: string.isRequired,
  envSpace: string.isRequired,
  parentId: string.isRequired
};
